import React from 'react';
import { connect } from 'react-redux';
import {Link, withRouter} from 'react-router';
import {isMobile} from 'react-device-detect';
import PublicProject from '../../eappcomponents/commons/job/public-project';


import ReactGA from 'react-ga';
import Splash_Signup from "../commons/splash_signup";

var pricetable = [];
pricetable[0] = [];
pricetable[0]["pricetable"] = [];

class ProjectPostPage extends React.Component {
	constructor(props) {
		super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
	}

    state = {
	    init: false,
        have_errors: 0,
        user_profile: pricetable,
        menuShow: false,
        basics: {
            job_title: '',
            job_function: '',
            job_start: false,
            job_start_date: null,
            job_exp: null,
            job_apply_start_date: null,
            job_profile: false,
            job_tracking: '',
            job_tracking_url: '',
            job_type: '',
            job_employment: '',
            job_duration: '',
            job_study: '',
            job_feed: '',
        },
        details: {
            job_description: '',
            job_estimate: '',
            job_cost: '',
            job_video: '',
            job_video_file: '',
            job_salary: '',
            job_per_salary: '',
            job_pay_salary: '',
            job_benefits: '',
            job_location: '',
            job_across: false,
            job_type_word: false,
            job_required_01: false,
            job_required_02: false,
            job_required_03: false,
            job_required_04: false,
        },
        preferences: {
            job_early_grad_month: 0,
            job_early_grad_year: 0,
            job_last_grad_month: 0,
            job_last_grad_year: 0,
            job_school_year_01: false,
            job_school_year_02: false,
            job_school_year_03: false,
            job_school_year_04: false,
            job_school_year_05: false,
            job_school_year_06: false,
            job_school_year_07: false,
            job_school_year_08: false,
            job_work_auth_01: false,
            job_work_auth_02: false,
            job_work_auth_03: false,
            job_work_auth_04: false,
            job_work_auth_05: false,
            job_work_auth_06: false,
            job_work_auth_07: false,
            job_work_auth_08: false,
            job_work_auth_09: false,
            job_gpa: '',
            job_major: '',
            job_desired_skill: [],
            job_work_experience: '',
            c_choosed: [],
            choosed: [],
        },
        schools: {
            lst_school_data: [],
            job_school_fr: [],
            job_school_to: [],
            global_apply: '',
            global_post: '',
        }
    };

    componentWillMount() {}

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        this.props.router.push(link);
    }

    render() {
        if (isMobile) {
            return (
                <div id={"job-post-home"}>
                    <div className={"block-001 row mr0"}>
                        <Link to="/projectsupport"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/pj/project-support.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/business/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/projects/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className={"mobile_wrapper"}>
                        <PublicProject
                            ref="child"
                            job_state={this.state}
                            versity_project={true}
                        />
                    </div>
                </div>
            )
        }
        return (
            <div id={"job-post-home"}>
                <div className={"block-002 row mr0"}>
                    <div className="pc-header">
                        <div className="splash_logo">
                            <Link to="/projectsupport"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/pj/project-support.png"/></Link>
                        </div>
                        <div className={"pc-header-btn"}>
                            <Link className="btn_join" to="/business/signup">Join</Link>
                            <Link className="btn_login" to="/projects/signin">Sign in</Link>
                        </div>
                    </div>
                </div>
                <div className={"pc_wrapper row"}>
                    <div className={"col-xs-9 pd0"}>
                        <PublicProject
                            ref="child"
                            job_state={this.state}
                            versity_project={true}
                        />
                    </div>
                    <div className={"col-xs-3 pd0"}>
                        <div className={"box-item mini-work"}>
                            <span className={"title"}>How it works</span>
                            <div className={"body"}>
                                <span className={"title01"}><img className={"img_logo"} src="/static/img/homeimg/pj/pj-01.png"/>Request</span>
                                <span>Answer a few simple questions about your project needs.</span>
                            </div>
                            <div className={"body"}>
                                <span className={"title01"}><img className={"img_logo"} src="/static/img/homeimg/pj/pj-02.png"/>Receive</span>
                                <span>You'll get offers from our curated list of interns.</span>
                            </div>
                            <div className={"body"}>
                                <span className={"title01"}><img className={"img_logo"} src="/static/img/homeimg/pj/pj-03.png"/>Hire</span>
                                <span>When you're ready, hire the right interns with confidence.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
ProjectPostPage.propTypes = {
  router: React.PropTypes.shape({
    push: React.PropTypes.func.isRequired
  }).isRequired
};

const mapStateToProps = function(store) {
    return {
        login_user: store.userState.user
    };
};
export default connect(mapStateToProps)(withRouter(ProjectPostPage));


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/project-post.js
 **/